"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var tslib_1 = require("tslib");
require("./text.css");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
/** Basic text writing, including body text, footnote and more. */
var Text = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'p' : _b, _c = _a.size, size = _c === void 0 ? 'paragraph' : _c, children = _a.children, className = _a.className, _d = _a.dataTest, dataTest = _d === void 0 ? 'text' : _d, appearance = _a.appearance, other = tslib_1.__rest(_a, ["type", "size", "children", "className", "dataTest", "appearance"]);
    var classes = (0, classnames_1.default)('dsc-text', size ? "is-".concat(size) : null, appearance && "is-".concat(appearance), className);
    return React.createElement(type, tslib_1.__assign(tslib_1.__assign({}, other), { className: classes, 'data-test': dataTest }), children);
};
exports.Text = Text;
exports.Text.displayName = 'Text';
//# sourceMappingURL=text.js.map